import type { AuditEvent, AuthUser, ManagedUser } from '../api'
import { AuditEventsView } from './AuditEventsView'

type Props = {
	activityUser: ManagedUser
	currentUser: AuthUser
	userEvents: AuditEvent[]
	userEventsLoading: boolean
	activeToggling: boolean
	onCloseBackdrop: () => void
	onToggleActive: () => void
	onEditProfile: () => void
}

export function AccountActivityModal({
	activityUser,
	currentUser,
	userEvents,
	userEventsLoading,
	activeToggling,
	onCloseBackdrop,
	onToggleActive,
	onEditProfile,
}: Props) {
	return (
		<div className="modal-backdrop" onClick={onCloseBackdrop}>
			<div className="modal-card modal-wide" onClick={(e) => e.stopPropagation()}>
				<div className="modal-activity-header">
					<div className="modal-activity-title-block">
						<h2>Учётка: {activityUser.login}</h2>
						<div className="modal-activity-status-row">
							<span className={activityUser.is_active ? 'status-badge status-badge-on' : 'status-badge status-badge-off'}>
								{activityUser.is_active ? 'Учётка активна' : 'Учётка заблокирована'}
							</span>
							{activityUser.id === currentUser.user_id && activityUser.is_active ? (
								<span className="muted modal-activity-self-hint">Свою учётку нельзя заблокировать здесь</span>
							) : (
								<button type="button" className="secondary-btn" disabled={activeToggling} onClick={() => void onToggleActive()}>
									{activeToggling ? '…' : activityUser.is_active ? 'Заблокировать' : 'Включить'}
								</button>
							)}
						</div>
					</div>
					<div className="modal-activity-header-actions">
						<button type="button" className="primary-btn" onClick={onEditProfile}>
							Редактировать данные
						</button>
					</div>
				</div>
				{userEventsLoading ? (
					<p className="muted">Загрузка...</p>
				) : (
					<AuditEventsView events={userEvents} showLoginColumn={false} variant="modal" />
				)}
				<div className="modal-actions">
					<button type="button" className="secondary-btn" onClick={onCloseBackdrop}>
						Закрыть
					</button>
				</div>
			</div>
		</div>
	)
}
